import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Header from "./Header";
import BottomNav from "./BottomNav";

import Dashboard from "../pages/Dashboard";
import FoodTracking from "../pages/FoodTracking";
import DietPlans from "../pages/DietPlans";
import WorkoutPlans from "../pages/Workout/WorkoutPlans";
import Profile from "../pages/Profile";
import PremiumPage from "../pages/PremiumPage";

const MainLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <Header />

      <main className="px-4 pt-4">
        <Routes>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="food" element={<FoodTracking />} />
          <Route path="diet" element={<DietPlans />} />
          <Route path="workout" element={<WorkoutPlans />} />
          <Route path="profile" element={<Profile />} />
          <Route path="premium" element={<PremiumPage />} />

          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </main>

      <BottomNav />
    </div>
  );
};

export default MainLayout;
